module.exports = __webpack_public_path__ + "static/media/EricOh.b02449db.webp";